export default __webpack_public_path__ + "static/media/navbar-pricing-orange.3235e865.svg";